import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20airplane%20first%20class%20cabin%20interior%20at%20sunset%20with%20warm%20golden%20light%20streaming%20through%20windows%2C%20cream%20leather%20seats%2C%20elegant%20table%20setting%20with%20champagne%2C%20spacious%20private%20suite%20atmosphere%2C%20cinematic%20lighting%2C%20soft%20ambient%20glow&width=1920&height=900&seq=hero-main-01&orientation=landscape"
          alt="诱人的飞行 - 奢华航空体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="font-heading text-2xl md:text-5xl font-bold text-white leading-tight max-w-3xl mx-auto">
          开启令人心动的天空之旅
        </h1>
        <p className="mt-4 md:mt-6 text-sm md:text-lg text-white/80 max-w-xl mx-auto leading-relaxed">
          从独家航线到奢华机舱，我们为你精选全球最具吸引力的飞行方案，让每一次起飞都成为难忘旅程的开始
        </p>
        <div className="mt-6 md:mt-8 flex items-center justify-center gap-3">
          <Link
            to="/category/luxury-flights"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            探索奢华航班
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/category/flight-tips"
            className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            飞行攻略
            <i className="ri-flight-takeoff-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}